export default __webpack_public_path__ + "static/media/profile.1e5ee720.jpg";